import * as mqttClient from './mqttClient';

const handlers = {} as { [key: string]: Function[] };
let hasBoundToMqtt = false;

export function subscribe(topic: string) {
    if (!hasBoundToMqtt) {
        hasBoundToMqtt = true;
        initEventHandler();
    }

    mqttClient.subscribe(topic);
}

export function unsubscribe(topic: string) {
    mqttClient.unsubscribe(topic);
}

export function on(topic: string, handler: Function) {
    if (!handlers[topic]) {
        handlers[topic] = [];
    }

    handlers[topic].push(handler);
}

export function off(topic: string, handler: Function) {
    /* istanbul ignore else  */
    if (handlers[topic]) {
        const index = handlers[topic].indexOf(handler);

        /* istanbul ignore else  */
        if (index > -1) {
            handlers[topic].splice(index, 1);
        }
    }
}

export function initEventHandler() {
    mqttClient.onMessage((topic, message: JSON) => {
        if (handlers[topic]) {
            handlers[topic].forEach(handler => {
                handler(message);
            });
        }
    });
}
